export enum UserRole {
  DISTRIBUTOR = 'distributor',
  INSTALLER = 'installer',
  ADMINISTRATOR = 'administrator',
  COUNTRY_ADMINISTRATOR = 'country_administrator',
  TELEMARKETING = 'telemarketing',
}
